import { render, staticRenderFns } from "./StokListesiDetay.vue?vue&type=template&id=715bc47c"
import script from "./StokListesiDetay.vue?vue&type=script&lang=js"
export * from "./StokListesiDetay.vue?vue&type=script&lang=js"
import style0 from "./StokListesiDetay.vue?vue&type=style&index=0&id=715bc47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports